<template>
  <article class="add-bucket-article">
    <Ariane class="ariane" :steps="STEPS_ITEMS" :selectedStepId="step" />

    <!-- STEP 1 -->
    <div v-show="step === 1">
      <h3>Choisissez vos menu</h3>
      <WeekCalendar
        ref="weekCalendar"
        :updatable="false"
        :selectable="true"
        :navigationTop="true"
        :selectedMealsId="computedSelectedMealsId"
      />
    </div>

    <!-- STEP 2 -->
    <div v-if="step === 2">
      <p>Choisissez les ingrédients à acheter</p>
      <input placeholder="Ajouter un ingrédient" /><button>Ajouter</button>
      <br /><br />
      <div class="all-ingredients">
        <div class="ingredients-to-keep">
          <div
            class="ingredient-container"
            v-for="(ingredient, index) in computedSelectedIngredientsToKeep"
            :key="index"
          >
            <b>{{ ingredient.title }}</b>
            <div class="circle" v-tooltip="ingredient.mealsText">
              <p>{{ ingredient.count }}</p>
            </div>
            <button
              class="button little-button"
              @click="removeIngredient(ingredient)"
            >
              Pas cette fois
            </button>
          </div>
        </div>

        <div class="ingredients-to-leave">
          <div
            class="ingredient-container"
            v-for="(ingredient, index) in computedSelectedIngredientsToLeave"
            :key="index"
          >
            <b>{{ ingredient.title }}</b>
            <div class="circle" v-tooltip="ingredient.mealsText">
              <p>{{ ingredient.count }}</p>
            </div>
            <button
              class="button little-button"
              @click="addIngredient(ingredient)"
            >
              Remettre dans la liste
            </button>
            <button
              class="button little-button"
              @click="addIngredient(ingredient)"
            >
              Jamais dans la liste
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- STEP 3 -->
    <div v-if="step === 3">
      <div class="all-ingredients">
        <div class="ingredients-items">
          <h3>Pour chaque ingrédient, choisissez le produit à acheter</h3>
          <div
            class="ingredient-container"
            v-for="(ingredient, index) in computedSelectedIngredientsToKeep"
            :key="index"
          >
            <b>{{ ingredient.title }}</b>
            <div class="circle" v-tooltip="ingredient.mealsText">
              <p>{{ ingredient.count }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <p class="text-error">{{ error }}</p>
    <div class="btn-container">
      <button class="button" v-if="step > 1" @click="previousStep">
        <Icon icon="fas fa-chevron-left" text="Étape précédente" />
      </button>
      <button class="button" v-if="step < STEPS_ITEMS.length" @click="nextStep">
        <Icon
          icon="fas fa-chevron-right"
          text="Étape suivante"
          :icon-after="true"
        />
      </button>
      <button class="button" v-else-if="step === STEPS_ITEMS.length">
        <Icon icon="fas fa-chevron-right" :icon-after="true" text="Valider" />
      </button>
    </div>
  </article>
</template>

<script>
import _ from 'lodash';

import WeekCalendar from '../../Calendar/WeekCalendar.vue';
import bucketsService from '../../../services/buckets.service';

import Ariane from '../../Ariane/Ariane.vue';
import Icon from '../../Utils/Icon.vue';
import plannedMealsService from '../../../services/plannedMeals.service';

const STEPS_ITEMS = [
  { id: 1, title: 'select-meals' },
  { id: 2, title: 'choose-ingredients' },
  { id: 3, title: 'shop-list' },
  // { id: 3, title: 'choose-products' },
  // { id: 4, title: 'validate' },
];
export default {
  components: {
    WeekCalendar,
    Ariane,
    Icon,
  },
  data() {
    return {
      STEPS_ITEMS,
      step: 1,
      bucketId: null,
      bucket: {
        selectedMeals: [],
      },
      selectedIngredients: [],
      error: '',
    };
  },
  async created() {
    this.bucketId = _.get(this.$route.params, 'bucketId', null);
    if (this.bucketId) {
      await this.getBucket();
    }
  },
  methods: {
    /**
     * Récupère le panier si existant
     */
    async getBucket() {
      this.bucket = await bucketsService.getBucket(this.bucketId);
      if (this.bucket) {
        this.step = this.bucket.step || 1;
        this.selectedIngredients = _.get(
          this.bucket,
          'selectedIngredients',
          []
        );
        await this.getMealsFromId();
      } else {
        // Bucket supprimé ?
        this.$router.push('/shopping');
      }
    },

    /**
     * Récupère les meals à partir des id
     */
    async getMealsFromId() {
      const promises = [];
      this.bucket.selectedMealsId.forEach((plannedMealId) => {
        promises.push(
          plannedMealsService
            .getPlannedMeal(plannedMealId)
            .then((plannedMeal) => {
              // On redécoupe pour éviter le ciruclar JSON error.
              // On garde meal.id, meal.title, meal.ing.title, meal.ing.id
              return {
                plannedMealId: _.get(plannedMeal, 'id', null),
                meal: {
                  mealId: _.get(plannedMeal, 'meal.id', null),
                  title: _.get(plannedMeal, 'meal.title', ''),
                  ingredients: _.get(plannedMeal, 'meal.ingredients', []).map(
                    (ing) => {
                      return {
                        title: _.get(ing, 'title', ''),
                        ingredientId: _.get(ing, 'ingredientRef.id', null),
                      };
                    }
                  ),
                },
              };
            })
        );
      });
      const plannedMeals = await Promise.all(promises);
      // force update
      this.$set(this.bucket, 'selectedMeals', plannedMeals);
    },

    /**
     * Récupère les menus sélectionnés sur le calendrier
     */
    getSelectedPlannedMeals() {
      return this.$refs.weekCalendar.getSelectedPlannedMeals();
    },
    /**
     * Passe à l'étape suivante
     */
    async previousStep() {
      if (this.step > 1) {
        this.step -= 1;
        await this.saveStep();
      }
    },
    async nextStep() {
      let allowed = false;
      let res = {};
      switch (this.step) {
        case 1:
          res = await this.checkSelectedMealsValidity();
          allowed = res.allowed;
          // On redirige vers le /bucket-title
          if (res.redirectToBucket) {
            this.redirectToBucket();
          }
          break;
        case 2:
          res = await this.checkSelectedIngredientsValidity();
          allowed = res.allowed;
          break;
        default:
          console.error('[Bucket] Step not found:', this.step);
      }

      this.error = '';
      if (allowed) {
        this.step += 1;
        await this.saveStep();
      } else {
        this.error = res.error || 'Unexpected error';
      }
    },

    /**
     * Enregistre l'étape dans le bucket
     */
    saveStep() {
      return bucketsService.updateBucket(this.bucketId, { step: this.step });
    },

    /**
     * Vérifie l'étape 1 : la sélection sur le calendrier
     */
    async checkSelectedMealsValidity() {
      const res = {};
      const selectedMeals = this.getSelectedPlannedMeals();
      if (selectedMeals.length <= 0) {
        res.error = 'Veuillez sélectionner au moins 1 menu';
      } else {
        // On récupère les meals comme il faut
        this.bucket = {
          selectedMealsId: selectedMeals.map((meals) => meals.id),
        };
        await this.getMealsFromId();
        // On a modifié this.bucket.selectedMeals, on récupère tous les ingrédients
        this.selectedIngredients = this.calculateSelectedIngredients();
        // On prépare la requête
        const bucketData = {
          selectedMealsId: this.bucket.selectedMealsId,
          selectedIngredients: this.selectedIngredients,
        };
        // On modifie en base
        const bucketRef = await this.createOrUpdateBucket(bucketData);
        if (!this.bucketId) {
          // On enregistre l'id (uniquement pour la création)
          this.bucketId = bucketRef.id;
          res.redirectToBucket = true;
        }
        res.allowed = true;
      }
      return res;
    },

    /**
     * Vérifie l'étape 2 : la sélection des ingrédients
     */
    async checkSelectedIngredientsValidity() {
      const res = {
        allowed: true,
      };
      if (this.selectedIngredients.length === 0) {
        res.allowed = false;
        res.error = 'Aucun ingrédient dans la liste';
        return res;
      }
      return res;
    },

    /**
     * Créer un panier
     */
    createOrUpdateBucket(data) {
      if (this.bucketId) {
        // Si existant, on modifie
        return bucketsService.updateBucket(this.bucketId, data);
      }
      // Sinon on insert
      return bucketsService.createBucket(data);
    },

    /**
     * Redirige vers le panier quand il est créé
     */
    redirectToBucket() {
      this.$router.push(`/bucket/${this.bucketId}`);
    },

    /**
     * Calcul la liste des ingrédients en groupant.
     */
    calculateSelectedIngredients() {
      const ingredients = [];
      this.computedSelectedMeals.forEach((plannedMeal) => {
        plannedMeal.meal.ingredients.forEach((ing) => {
          // On regarde si cet ingredient est déjà dans la liste
          let ingIndex = _.findIndex(
            ingredients,
            (i) => i.ingredientId === ing.ingredientId
          );
          if (ingIndex === -1) {
            // pas encore dedans
            ingredients.push({
              ingredientId: ing.ingredientId,
              title: ing.title,
              count: 0, // count 0 car on fait +1 après
              mealsText: '', // le text de la tooltip
              meals: [],
              toKeep: true,
            });
            ingIndex = ingredients.length - 1;
          }
          // On ajoute le meal, et on incrément count
          ingredients[ingIndex].count += 1;
          // On ajoute le meal (sans les ingrédients car inutile)
          ingredients[ingIndex].meals.push({
            plannedMealId: plannedMeal.plannedMealId,
            mealId: plannedMeal.meal.mealId,
            title: plannedMeal.meal.title,
          });
          // On ajoute le texte (pas de virgule si c'est le premier)
          let currentText = ingredients[ingIndex].mealsText;
          if (currentText.length > 0) {
            currentText += ', ';
          }
          currentText += plannedMeal.meal.title;
          ingredients[ingIndex].mealsText = currentText;
        });
      });
      return ingredients;
    },

    /**
     * Suppr un ingrédient de la liste
     */
    removeIngredient(ingredient) {
      this.setIngredientToKeep(ingredient, false);
    },
    /**
     * Remet l'ingrédient dans la liste
     */
    addIngredient(ingredient) {
      this.setIngredientToKeep(ingredient, true);
    },
    /**
     * Change le toKeep d'un ingrédient
     */
    async setIngredientToKeep(ingredient, toKeep) {
      const ingIndex = _.findIndex(
        this.selectedIngredients,
        (ing) => ing.ingredientId === ingredient.ingredientId
      );
      if (ingIndex > -1) {
        this.selectedIngredients[ingIndex].toKeep = toKeep;
      }
      await this.saveSelectedIngredients();
    },

    /**
     * Enregistre les selectedIngredients
     */
    async saveSelectedIngredients() {
      const dataToUpdate = {
        selectedIngredients: this.selectedIngredients,
      };
      return this.createOrUpdateBucket(dataToUpdate);
    },
  },
  computed: {
    computedSelectedMeals() {
      return _.get(this.bucket, 'selectedMeals', []);
    },
    computedSelectedMealsId() {
      return _.get(this.bucket, 'selectedMealsId', []);
    },
    /**
     * Retourne les ingrédients de la colonne à garder
     */
    computedSelectedIngredientsToKeep() {
      return this.selectedIngredients.filter((ing) => ing.toKeep);
    },
    /**
     * Retourne les ingrédients de la colonne à ne pas prendre en compte
     */
    computedSelectedIngredientsToLeave() {
      return this.selectedIngredients.filter((ing) => !ing.toKeep);
    },
  },
  watch: {
    getSelectedPlannedMeals() {
      if (this.error !== '' && this.getSelectedPlannedMeals.length > 0) {
        // Si on avait une erreur, on l'enlève quand la sélection change
        this.error = '';
      }
    },
  },
};
</script>

<style lang="scss" scoped src="./Bucket.scss"></style>
